import React from "react";
import {connect} from "react-redux";
import {Button, Modal, ModalBody, ModalHeader, Spinner} from "reactstrap";
import {useTranslation} from "react-i18next";
import {
  STEP_TYPE_CHOICE,
  STEP_TYPE_HTTP_REQUEST,
  STEP_TYPE_QUESTION,
  STEP_TYPE_STORE_LEAD,
  STEP_TYPE_TEXT,
} from "../../../constants";
import {
  apiCustomFields,
} from "../../../thunks/ApiModel";

const ModalAddVariable = ({dataForm, text, change, apiCustomFields}) => {
  if (dataForm?.type?.id && [STEP_TYPE_CHOICE, STEP_TYPE_HTTP_REQUEST, STEP_TYPE_QUESTION, STEP_TYPE_STORE_LEAD, STEP_TYPE_TEXT].includes(dataForm.type.id)) {
    const {t} = useTranslation();
    const [state, setState] = React.useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [loader, setLoader] = React.useState(false);

    const openModal = () => {
      setLoader(true);
      apiCustomFields(data => {
        if (data.status === 'ok') {
          setState([
            {name: 'name', dtype: {id: 'text', name: 'back.bot.text'}},
            {name: 'phone', dtype: {id: 'text', name: 'back.bot.text'}},
            ...data.result.results
          ]);
          setLoader(false);
        } else {
          setLoader(false);
        }
      });
      setIsOpen(true)
    };

    const closeModal = () => {
      setIsOpen(false);
    };

    const addVariable = (variable) => {
      change({target: {value: `${text} {{ ${variable} }}`}} );
      closeModal();
    };

    return <>
      <Button type="button" color="primary" size="sm" onClick={openModal} style={{fontSize: '11px'}}>
        + {t('add_variable', 'Add variable')}
      </Button>

      <Modal isOpen={isOpen} toggle={closeModal} size="md" scrollable>
        <ModalHeader toggle={closeModal}>
          {t('add_variable', 'Add variable')}
        </ModalHeader>
        <ModalBody className="p-0">
          <ul className="list-group">
            {loader ? <div className="text-center p-2"><Spinner/></div>:
            state.map((item, index) => (
              <button key={index} type="button" className="rounded-0 border-start-0 border-end-0 text-truncate list-group-item list-group-item-action"
                onClick={() => addVariable(item.name)}>
                {item.name} - <strong className="text-muted">{t(item.dtype.name)}</strong>
              </button>
            ))}
          </ul>
        </ModalBody>
      </Modal>
    </>
  } else {
    return null;
  }
}

const mapStateToProps = state => ({
  dataForm: state.APIForm.data,
});

const mapDispatchToProps = dispatch => ({
  apiCustomFields: (callback) => dispatch(apiCustomFields(callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddVariable);
